import { BODIES, type Body } from '../../lib/body.ts';
import { dv } from '../../i18n/dv.ts';
import { Icon } from '../../components/Icon.tsx';

// Council / WDC selector — a canonical Material 3 segmented button: an outlined
// container of connected segments divided by hairlines, the selected segment
// filled with secondary-container and showing a leading check. Shared by the
// dashboard cards and the per-body settings sections.
export function BodyToggle({ body, onChange }: { body: Body; onChange: (b: Body) => void }): JSX.Element {
  return (
    <div
      className="inline-flex items-center overflow-hidden rounded-full border border-[hsl(var(--border))]"
      role="group"
      aria-label={dv.body.label}
    >
      {BODIES.map((b, i) => {
        const active = b === body;
        return (
          <button
            key={b}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(b)}
            className={`inline-flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium transition-colors ${
              i > 0 ? 'border-s border-[hsl(var(--border))]' : ''
            } ${
              active
                ? 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]'
                : 'text-foreground hover:bg-black/[0.04] dark:hover:bg-white/[0.06]'
            }`}
          >
            {active && <Icon name="check" size={16} />}
            {dv.body[b]}
          </button>
        );
      })}
    </div>
  );
}
